export default __webpack_public_path__ + "static/media/LAS1000.34I-43770_-26125_0.a5c63d23.jpg";